import { render, staticRenderFns } from "./waterResourcesCarAccount.vue?vue&type=template&id=64493a8e&scoped=true&"
import script from "./waterResourcesCarAccount.vue?vue&type=script&lang=js&"
export * from "./waterResourcesCarAccount.vue?vue&type=script&lang=js&"
import style0 from "./waterResourcesCarAccount.vue?vue&type=style&index=0&id=64493a8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64493a8e",
  null
  
)

export default component.exports